import apiService from "./apiService";

const notificationService = {
    async getNotifications(limit=20){
        try{
            return (await apiService.get(`notifications/get/${limit}`,{},true)).data;
        }
        catch{
            return [];
        }
    },
    async markAsRead(id){
        try{
             await apiService.post(`notifications/${id}/mark-as-read`,{},true);
            return {success: true};
        }
        catch{
            return {success: false};
        }
    }

}


export default notificationService;